import { colors } from './index'
import configureStore from '../configureStore'
import convertStyleWithMultiplier from './styleHelper'

const dialogStyles = {
  dialogActions: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dialogActionsLanguage: {
    marginBottom: 8,
    marginTop: 8,
  },
  dialogBodyParagraph: { marginBottom: 16 },
  dialogButtonFont: { letterSpacing: 0.1 },
  dialogContent: { paddingHorizontal: 16 },
  dialogSingleAction: {
    backgroundColor: colors.white,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  dialogTitle: {
    color: colors.shark_grey,
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: 23,
    marginLeft: 16,
  },
  dialogTitleIcon: {
    fontSize: 60,
    fontWeight: 'bold',
    paddingRight: 20,
    textAlignVertical: 'center',
  },
  dialogTitleWithIconText: {
    color: colors.shark_grey,
    flex: 1,
    fontSize: 20,
    fontWeight: 'bold',
    textAlignVertical: 'center',
  },
  dialogTitleWithIconView: {
    alignItems: 'center',
    flexDirection: 'row',
    paddingBottom: 20,
    width: '100%',
  },
  wrappableDialogActions: {
    flex: 1,
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}

const Sheet = () => {
  const { storedData } = configureStore.getState()
  const { fontMultiplier } = storedData
  return convertStyleWithMultiplier(fontMultiplier || 1, dialogStyles)
}

export default Sheet()
